export const HOSTNAME = {
    localhost: 'localhost',
    sit: 'signin.sit.test.visma.net',
    int: 'signin.aws.int.test.visma.net',
    stag: 'signin.stag.visma.net',
    prod: 'signin.visma.net'
}
